import { baixarPost } from "../../../lib/download";

/**
 * Exporta o quadro da competência. Envia os ids visíveis para o arquivo
 * corresponder ao que a pessoa está vendo depois dos filtros; sem eles, o
 * servidor exporta o mês inteiro.
 */
export const exportarQuadro = (
  mes: number,
  ano: number,
  ids: number[],
  formato: "pdf" | "excel"
): Promise<void> =>
  baixarPost(
    "/portal-cliente/kanban/relatorio",
    { mes, ano, formato, ids },
    `quadro-${ano}-${String(mes).padStart(2, "0")}.${formato === "excel" ? "xlsx" : "pdf"}`
  );
